'use client'

import { WhiteLabelAssets } from '../../white-label-assets'
import { LoginCard } from '../login-card'
import { LoginCarousel } from '../login-carousel'
import { useThemeStore } from '@/lib/stores/theme-store'

interface RightLayoutProps {
  children: React.ReactNode
  titleShowcase: string
  brandName: string
  banners?: string | string[]
  /** Quando false, não exibe carrossel de capas (layout “solo” à direita). */
  showShowcase?: boolean
}

export function RightLayout({
  children,
  titleShowcase,
  brandName,
  banners,
  showShowcase = true,
}: RightLayoutProps) {
  const { currentTheme } = useThemeStore()
  const objectPosition = currentTheme?.login?.layout?.body?.imagePosition || 'center'
  const logoNavOnly =
    currentTheme?.login?.features?.logoNavOnly ||
    (currentTheme as any)?.showcase_content?.login?.logoNavOnly

  // Novas propriedades de título e descrição
  const showTitle = currentTheme?.login?.features?.showTitle ?? true
  const titleText = currentTheme?.login?.features?.titleText || currentTheme?.title
  const showDescription = currentTheme?.login?.features?.showDescription ?? false
  const descriptionText = currentTheme?.login?.features?.descriptionText || currentTheme?.description

  const parsedBanners =
    typeof banners === 'string'
      ? (() => {
          try {
            const parsed = JSON.parse(banners)
            return Array.isArray(parsed) ? parsed.filter(Boolean) : (banners ? [banners] : [])
          } catch {
            return banners ? [banners] : []
          }
        })()
      : Array.isArray(banners)
        ? banners.filter(Boolean)
        : []
  const hasBanners = parsedBanners.length > 0
  const showCarousel = showShowcase && hasBanners
  const showSideCopy =
    (showTitle && titleText) || (showDescription && descriptionText)

  return (
    <div className="h-full flex items-center relative overflow-hidden rounded-xl">
      {/* Background with white-label image */}
      <div className="absolute inset-0 rounded-xl overflow-hidden m-2">
        <WhiteLabelAssets
          type="background"
          className="absolute inset-0 scale-110 origin-left w-full h-full"
          priority={true}
          alt="Login background"
          objectPosition={objectPosition}
        />
        <div className="absolute inset-0 bg-gradient-to-l from-background/20 to-transparent" />
      </div>

      {/* Wrapper para centralização vertical */}
      <div className="container h-full flex items-center relative z-10">
        {/* Container de conteúdo - altura determinada pelo card */}
        <div className="flex items-end gap-8 w-full">
          <div id="carousel-container" className="flex-1 min-w-0 flex flex-col gap-8"
            style={{
              gap: logoNavOnly ? 0 : 32
            }}>
            {showSideCopy && (showCarousel || !showShowcase) && (
              <div className="space-y-2 mb-4">
                {showTitle && titleText && (
                  <div
                    className="text-4xl font-bold"
                    style={{ color: 'var(--login-body-title)' }}
                    dangerouslySetInnerHTML={{ __html: titleText }}
                  />
                )}
                {showDescription && descriptionText && (
                  <div
                    className="text-lg"
                    style={{ color: 'var(--login-body-description)' }}
                    dangerouslySetInnerHTML={{ __html: descriptionText }}
                  />
                )}
              </div>
            )}

            {showCarousel && <LoginCarousel banners={parsedBanners} />}
          </div>

          {/* Login Card - À direita */}
          <div className="flex-shrink-0 flex-grow-0">
            <LoginCard titleShowcase={titleShowcase} brandName={brandName}>
              {children}
            </LoginCard>
          </div>
        </div>
      </div>
    </div>
  )
}

